import { render } from "./AutoPartsSales.vue?vue&type=template&id=b066bb24&scoped=true"
import script from "./AutoPartsSales.vue?vue&type=script&lang=js"
export * from "./AutoPartsSales.vue?vue&type=script&lang=js"

import "./AutoPartsSales.vue?vue&type=style&index=0&id=b066bb24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b066bb24"]])

export default __exports__